import { http } from '../utils/http';

export const uploadFile = async data => {
  return await http.post(`/api/basic-ability/file/uploadFile`, { file: data, process: 'resize,l_200' }, true);
};
